/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Operacje na obiektach
 *
 * @export
 * @class ObjectTools
 * @extends {AjaxTools}
 */
import { AjaxTools } from "./AjaxTools.class";

export class ObjectTools extends AjaxTools {
	constructor() {
		super();
	}
	// ****************************************************************************************************
	// obliczanie realnej wysokosci obiektu
	// ****************************************************************************************************
	realHeight(obj) {
		return obj.height() + Number(obj.css('padding-top').replace('px', '')) + Number(obj.css('padding-bottom').replace('px', '')) + Number(obj.css('border-top-width').replace('px', '')) + Number(obj.css('border-bottom-width').replace('px', ''));
	}
	// ****************************************************************************************************
	// obliczanie realnej szerokosci obiektu
	// ****************************************************************************************************
	realWidth(obj) {
		return obj.width() + Number(obj.css('padding-left').replace('px', '')) + Number(obj.css('padding-right').replace('px', '')) + Number(obj.css('border-left-width').replace('px', '')) + Number(obj.css('border-right-width').replace('px', ''));
	}
	// ****************************************************************************************************
	// metoda czekajaca na załadowanie sie obiektów
	// ****************************************************************************************************
	waitForLoadingObjects(selector, func, waitForLoadingObjectsTimer) {
		waitForLoadingObjectsTimer = null;
		var loaded = 0;
		$(selector).each(function (i, e) {
			var elemId = $(e).attr('id');
			if (elemId) {
				if (document.getElementById(elemId).complete) {
					loaded++;
					if (loaded == $(selector).length) {
						func();
					}
				}
				else {
					setTimeout(function () { this.waitForLoadingObjects(selector, func, waitForLoadingObjectsTimer); }.bind(this), 100);
					return false;
				}
			}
			else {
				$(e).attr('id', 'random-' + selector + '-' + Math.floor((Math.random() * 100000) + 1));
				setTimeout(function () { this.waitForLoadingObjects(selector, func, waitForLoadingObjectsTimer); }.bind(this), 100);
				return false;
			}
		}.bind(this));
	}
	// ****************************************************************************************************
	// ustawienie wymiarów i pozycji obrazów w kontenerach (DOM: div.productImgCont >> a >> img)
	// ****************************************************************************************************
	setImg(selector) {
		if (selector === undefined)
			selector = '.productImgCont img';
		var images = $(selector);
		if (images.length > 0) {
			images.each(function (i, e) {
				var wMax = ($(e).parent().parent().width() < $(e).attr('data-img-width-limit')) ? $(e).parent().parent().width() : $(e).attr('data-img-width-limit'); // div > img ?
				$(e).removeAttr('style'); // img
				$(e).parent().height(wMax); //a
				if ($(e).width() > wMax || $(e).height() > wMax) { // czy img wymaga modyfikacji rozmiaru
					if ($(e).width() > $(e).height()) {
						$(e).width(wMax);
					}
					else {
						$(e).height(wMax);
					}
				}
			});
		}
	}
	// ****************************************************************************************************
	// Sprawdza, czy dany kontener ma elementy, które przekraczają jego wysokość.
	// ****************************************************************************************************
	checkOverflowY(selector) {
		//let overflowY = $(selector).css('overflow-y');
		//let overflowYrestore = overflowY;

		let scrollHeight = $(selector)[0].scrollHeight;
		let height = $(selector).height();

		return scrollHeight > height;
	}
	checkOverflowYOld(container) {
			var curOverflow = ( container.style.overflow === undefined )? false : container.style.overflow;

			if (!curOverflow || curOverflow === "visible")
				container.style.overflow = "hidden";

			container.style.overflow = curOverflow;

			return container.clientWidth < container.scrollWidth || container.clientHeight < container.scrollHeight;
	}
	// ****************************************************************************************************
	// Sprawdza, czy dany kontener ma elementy, które przekraczają jego granicę.
	// TODO: tu coś nie gra z warunkami, lepiej stosować spr overflow Y lub X
	// ****************************************************************************************************
	checkOverflow(container) {
		var curOverflow = container.style.overflow;
		if (!curOverflow || curOverflow === "visible")
			container.style.overflow = "hidden";
		container.style.overflow = curOverflow;
		return container.clientWidth < container.scrollWidth || container.clientHeight < container.scrollHeight;
	}
	// ****************************************************************************************************
	// Dopasowanie ilości znaków textu w obiekcie multiline ()
	// ****************************************************************************************************
	adjustStringToElHeight(obj, maxLines, maxHeight, orginalHtml, cutOutCounter) {
		if (maxLines === undefined)
			maxLines = 1;
		if (orginalHtml === undefined)
			orginalHtml = obj.html().replace(/\s\s+/g, ' ');
		if (maxHeight === undefined) {
			var testString = '';
			for (var i = 1; i < maxLines; i++) {
				testString += i + '<br>';
			}
			obj.html(testString + maxLines);
			maxHeight = obj.height();
		}
		if (cutOutCounter === undefined)
			cutOutCounter = 0;
		var testHtml = orginalHtml.substring(0, orginalHtml.length - cutOutCounter);
		obj.html(testHtml);
		if (obj.height() <= maxHeight) {
			if (cutOutCounter > 0)
				testHtml = testHtml.substring(0, testHtml.length - 4) + '...';
			obj.html(testHtml).height(maxHeight);
			return false;
		}
		else {
			cutOutCounter += 1;
			this.adjustStringToElHeight(obj, maxLines, maxHeight, orginalHtml, cutOutCounter);
		}
	}
	// ****************************************************************************************************
	// Wyrównanie wysokości elementow po: klasie i data-height-fix-group
	// ****************************************************************************************************
	alignElementsHeight(fixGroupClass) {
		var that = this;
		var heightFixGroup = that.resetElementsHeight(fixGroupClass);
		// wyszukanie najwyzszego elementu w podgrupie
		$.each(heightFixGroup, function (k, v) {
			$('.' + fixGroupClass + ' [data-height-fix-group=' + k + ']').each(function (i, e) {
				if ($(e).height() > heightFixGroup[k])
					heightFixGroup[k] = $(e).height();
			});
		});
		// podstawienie wysokosci
		$.each(heightFixGroup, function (k, v) {
			$('.' + fixGroupClass + ' [data-height-fix-group=' + k + ']').each(function (i, e) {
				//$(e).height(heightFixGroup[k]); //bardzo nie wydajne!!!! (uwzględnia padding)
				$(e).css('height', heightFixGroup[k] + 'px'); // nie uwzględnia paddingu wtedy jest szybkie
			});
		});
	}
	// ****************************************************************************************************
	// Wyczyszczenie wysokości elementow po alignElementsHeight ------ po klasie i data-height-fix-group
	// ****************************************************************************************************
	resetElementsHeight(fixGroupClass) {
		var heightFixGroup = new Object;
		// czyszczenie i rozpoznanie grup elementow
		$('.' + fixGroupClass + ' .heightFix').each(function (i, e) {
			$(e).css('height', 'auto');
			var newGroup = $(e).attr('data-height-fix-group');
			if (!(newGroup in heightFixGroup)) {
				heightFixGroup[newGroup] = 0;
			}
		});
		return heightFixGroup;
	}
	// ****************************************************************************************************
	// Wyrównanie szerokości elementow po: klasie i data-width-fix-group
	// ****************************************************************************************************
	alignElementsWidth(fixGroupClass) {
		var that = this;
		var widthFixGroup = that.resetElementsWidth(fixGroupClass);
		// wyszukanie najwyzszego elementu w podgrupie
		$.each(widthFixGroup, function (k, v) {
			$('.' + fixGroupClass + ' [data-width-fix-group=' + k + ']').each(function (i, e) {
				if ($(e).width() > widthFixGroup[k])
					widthFixGroup[k] = $(e).width();
			});
		});
		// podstawienie wysokosci
		$.each(widthFixGroup, function (k, v) {
			$('.' + fixGroupClass + ' [data-width-fix-group=' + k + ']').each(function (i, e) {
				//$(e).width(widthFixGroup[k]); //bardzo nie wydajne!!!! (uwzględnia padding)
				$(e).css('width', widthFixGroup[k] + 'px'); // nie uwzględnia paddingu wtedy jest szybkie
			});
		});
	}
	// ****************************************************************************************************
	// Wyczyszczenie szerokości elementow po alignElementsWidth ------ po klasie i data-width-fix-group
	// ****************************************************************************************************
	resetElementsWidth(fixGroupClass) {
		var widthFixGroup = new Object;
		// czyszczenie i rozpoznanie grup elementow
		$('.' + fixGroupClass + ' .widthFix').each(function (i, e) {
			$(e).css('width', 'auto');
			var newGroup = $(e).attr('data-width-fix-group');
			if (!(newGroup in widthFixGroup)) {
				widthFixGroup[newGroup] = 0;
			}
		});
		return widthFixGroup;
	}
	// ****************************************************************************************************
	// Powiększenie zdjęcia
	// ****************************************************************************************************
	initZoomImage(img) {
		let that = this;
		img.on('click', function () {
			if ($(window).width() > 752) {
				var imgHtml = '<img class="d-block imgZoomed mx-auto" src="' + img.attr('src') + '" title="' + img.attr('title') + '"/>';
				that.showModalAlert(imgHtml, '', 'modalWithZoomedImg noFooter noHeader closeBtnTopRight');
				$('.imgZoomed').off().on('click', function () {
					$('#modalAlert').modal('hide');
				});
			}
		});
	}
	// ****************************************************************************************************
	// zmiana stanu inputu
	// ****************************************************************************************************
	changeInputState(input) {
		if (input.is(':checked'))
			input.prop('checked', false).removeAttr('checked')
		else
			input.prop('checked', true).attr('checked','checked');
	}
}